export default "__VITE_PUBLIC_ASSET__0bd6a53b__"